import { jsxs as s, jsx as i } from "react/jsx-runtime";
import { c as t } from "../../../index-CvSFHqCB.js";
import * as d from "react";
import { c as v } from "../../../utils-BOFVZgHd.js";
import { Input as g } from "../../ui/input.js";
import { Label as b } from "../../ui/label.js";
const w = t("flex flex-col gap-1.5", {
  variants: {
    size: {
      default: "",
      sm: "max-w-sm",
      lg: "max-w-lg",
      full: "w-full"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), V = t(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
  {
    variants: {
      error: {
        true: "text-[var(--destructive)]",
        false: "text-[var(--foreground)]"
      }
    },
    defaultVariants: {
      error: !1
    }
  }
), h = t("text-sm text-[var(--destructive)]", {
  variants: {
    size: {
      default: "",
      sm: "text-xs",
      lg: "text-base",
      full: ""
    }
  },
  defaultVariants: {
    size: "default"
  }
}), I = d.forwardRef(
  ({ className: o, size: r, label: l, placeholder: n, error: e, required: f, field: m, fieldControl: c, id: u }, x) => {
    const p = d.useId(), a = u || m?.fieldId || p;
    return /* @__PURE__ */ s("div", { className: "w-full flex flex-col gap-1.5", children: [
      l && /* @__PURE__ */ s(b, { htmlFor: a, className: V({ error: !!e }), children: [
        l,
        f && " *"
      ] }),
      /* @__PURE__ */ i(
        g,
        {
          ...c?.field || {},
          id: a,
          ref: x,
          className: v(w({ size: r, className: o })),
          "aria-describedby": e ? `${a}-error` : void 0,
          "aria-invalid": !!e,
          placeholder: n || ""
        }
      ),
      e && /* @__PURE__ */ i("p", { className: h({ size: r }), id: `${a}-error`, children: e })
    ] });
  }
);
I.displayName = "TextField";
export {
  I as TextField,
  w as textFieldVariants
};
//# sourceMappingURL=index.js.map
